import React from 'react';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { ArrowDropDownIcon, palette, SimplePopover, TertiaryButton, TertiaryButtonGroup } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { getAccountAccessLevel, getGeneralInfo } from '@/store/account/actions';

import { ArrowDropdownContainer } from '../../../StyledComponents';
import { useTableMenuActions } from '../../hooks';
import { useDefaultContactActionMenuOptions } from '../../hooks/useDefaultContactActionMenuOptions';
import { useAddContactsToList } from '../../hooks/tableMenuActions/useAddContactsToList';

export const TableActionButtons = (): JSX.Element => {
    const { t } = useTranslation();
    const { listname } = useParams<{ listname: string }>();

    const accountAccessLevels = useSelector(getAccountAccessLevel);
    const { EnableContactFeatures } = useSelector(getGeneralInfo);
    const { addContactToList } = useAddContactsToList();

    const canModifyContacts = accountAccessLevels.includes(AccessLevel.ModifyContacts);
    const canExport = accountAccessLevels.includes(AccessLevel.Export);
    const isList = !!listname;
    const { tableMenuActions } = useTableMenuActions();

    const menuoptions = useDefaultContactActionMenuOptions();

    const buttons: JSX.Element[] = [];

    if (canModifyContacts && EnableContactFeatures) {
        buttons.push(
            <TertiaryButton
                id="add-to-list-button"
                key="table-add-to-list"
                onClick={() => addContactToList(false, null)}
                text={t('addtolist')}
            />
        );
    }
    if (canModifyContacts && isList) {
        buttons.push(
            <TertiaryButton
                id="move-to-list-button"
                key="table-move-to-list"
                onClick={() => addContactToList(true, null)}
                text={t('movetolist')}
            />
        );
    }
    if (canModifyContacts || canExport) {
        buttons.push(
            <SimplePopover
                id="more-actions"
                key="table-dropdown"
                options={menuoptions}
                type="custom"
                onItemClick={(e, obj: { label: string; value: string }): void => {
                    tableMenuActions(obj.value);
                }}
                placement={'bottom-end'}
            >
                <TertiaryButton
                    id="more-actions-button"
                    endIcon={
                        <ArrowDropdownContainer>
                            <ArrowDropDownIcon color={palette.indigo[6]} />
                        </ArrowDropdownContainer>
                    }
                    text={t('moreactions')}
                />
            </SimplePopover>
        );
    }
    return (
        <div>
            <TertiaryButtonGroup>{buttons}</TertiaryButtonGroup>
        </div>
    );
};
